import {observer} from 'mobx-react';
import {lazy} from 'react';
import {useNavigate} from 'react-router';
import {usePostHog} from 'posthog-js/react';
import {AdminProfileController} from './admin-profile-controller';
import {AdminProfileFormData} from './admin-profile-interface';
import {AdminProfileRequestImpl} from './admin-profile-request';
import {
  getDetectedTimezone,
  serializeTimezoneForApi,
} from '@utils/timezone';

const SetupPersonalProfilePage = lazy(() =>
  import('./admin-profile-page').then((module) => ({
    default: module.AdminProfilePage,
  })),
);

const SetupWorkspaceForm = lazy(() =>
  import('./admin-profile-form').then((module) => ({
    default: module.AdminProfileForm,
  })),
);

export const installAdminProfilePage = () => {
  const request = new AdminProfileRequestImpl();
  const controller = new AdminProfileController(request);

  const FormComponent = observer(() => {
    const navigate = useNavigate();
    const posthog = usePostHog();
    const onSubmit = async (data: AdminProfileFormData) => {
      const response = await controller.adminProfile({
        ...data,
        timezone: serializeTimezoneForApi(getDetectedTimezone()),
      });

      if (response) {
        if (window?.gtag_report_conversion) {
          window.gtag_report_conversion(window.location);
        }

        posthog?.identify(response?.id, {
          email: response?.email,
        });

        posthog?.capture('admin_signed_up');

        navigate('../email-sent', {replace: true});
      }
    };

    return <SetupWorkspaceForm onSubmit={onSubmit} />;
  });

  const Page = observer(() => (
    <SetupPersonalProfilePage FormComponent={FormComponent} />
  ));

  return {
    Page,
  };
};
